import { showToastError } from 'hooks/useToast'
import { typedArrayIncludes } from './type.utils'
import { FileExtension } from 'types/file.types'

/**
 * Validates a file based on the given constraints. Returns true if the file is valid, false otherwise.
 * Shows a toast error message if the file is invalid.
 */
export const validateFile = ({
    maxFileSizeMb,
    acceptedFileTypes = [],
    file,
}: {
    maxFileSizeMb?: number // megabytes
    acceptedFileTypes?: FileExtension[] // e.g. ['pdf', 'csv']
    file: File
}) => {
    const fileSizeMb = file.size / 1024 / 1024
    if (maxFileSizeMb && fileSizeMb > maxFileSizeMb) {
        showToastError(
            `File ${file.name} exceeds maximum size of ${maxFileSizeMb}MB`
        )
        return false
    }

    if (acceptedFileTypes.length > 0) {
        const fileExt = file.name.split('.').pop()?.toLowerCase() ?? ''
        if (!typedArrayIncludes(acceptedFileTypes, fileExt)) {
            showToastError(
                `File type ${fileExt} is not supported. Accepted types: ${acceptedFileTypes.join(
                    ', '
                )}`
            )
            return false
        }
    }

    return true
}
